import { bus, axios, i18n, apiURL } from '../main'

export default {
    state: { // state des Moduls wird direkt auf die variable state.modulX gemappt
        kreditor:{
            kreditor: "",
            iban: "",
            name: "",
            zusatz:"",
            strasse: "",
            hausnummer: "",
            plz: "",
            ort: "",
            emailVersand: 1,
            bank: { name: "", bcnr: "" }, // remote BANK INFO{}
            },
        SAPError:{},
        //Dies sind STATISCHE Werte der SAP Schnittstelle und daher fix reinkompiliert. /dbmilch/components/sap_connector/sap.getUserDefinition()
        fielddef:[
            {name:'iban', min:21, max:21},
            {name:'name', min:2, max:40},
            {name:'zusatz', min:0, max:40},
            {name:'strasse', min:1, max:60},
            {name:'hausnummer', min:0, max:10},
            {name:'plz', min:4, max:4},
            {name:'ort', min:2, max:40}
            ]
    },
    actions: { // call from outside as action: this.$store.dispatch('LOAD_abcd')
        loadZulagen: async function ({ commit }) {
            try {
                var kreditor = await axios.get(apiURL + 'zulagen.cfc?method=getKreditor' , { params: { locale: i18n.locale }})
                commit('setKreditor', kreditor.data)
            }
            catch (e) {
                bus.$emit('error', 'Kreditor konnte nicht geladen werden ..' + JSON.stringify(e.message))
            }
        },
        setKreditor: async function ({ state },kreditor) {
            
            kreditor.locale =  i18n.locale
            // ohne errorhandling, damit die übergeordnete fn den SendError abfangen kann
            await axios.get(apiURL + 'zulagen.cfc?method=setKreditor', { params: kreditor,timeout:45*1000 })  //immer alle

            //zuweisung am schluss damit im Fehlerfall der lokale Kreditor nicht überschrieben
            state.kreditor = kreditor
        },
        setEmailVersandZulagen: async function ({  commit }, emailVersand) {
            try {
                const formData = new FormData()
                formData.append('emailVersand', emailVersand)
                await axios.post(apiURL + 'zulagen.cfc?method=setEmailVersand', formData)
                commit('setEmailVersand', emailVersand)
            }
            catch (e) {
                bus.$emit('error', 'Error saving emailZulagen ... ' + JSON.stringify(e.message))
            }
        },
    },
    mutations: {
        setKreditor: function (state, value) {
            state.kreditor.kreditor = value.kreditor.toString()
            state.kreditor.iban = value.iban.toString()
            state.kreditor.name = value.name.toString()
            state.kreditor.zusatz = value.zusatz.toString()
            state.kreditor.strasse = value.strasse.toString()
            state.kreditor.hausnummer = value.hausnummer.toString()
            state.kreditor.plz = value.plz.toString()
            state.kreditor.ort = value.ort.toString()
            state.kreditor.emailVersand = value.emailVersand
        },
        setEmailVersand: function (state, value) {
            state.kreditor.emailVersand = value
        }
    }
}